import React, { Fragment } from 'react';

import { Text } from '@zapier/design-system';

import DateToNowWithTooltip from 'app/developer-v3/components/DateToNowWithTooltip';

type Props = {
  createdAt: string;
  email: string;
  isStaff: boolean;
  name: string;
};

function AuthorInfo({ createdAt, email, isStaff, name }: Props) {
  const isZapierEmail = email.endsWith('@zapier.com');

  return (
    <Text>
      {isZapierEmail && !isStaff ? (
        <Fragment>
          Created by <strong>Zapier</strong>
        </Fragment>
      ) : (
        <Fragment>
          Created by <strong>{name}</strong> ({email})
        </Fragment>
      )}{' '}
      <DateToNowWithTooltip date={new Date(createdAt)} />
    </Text>
  );
}

export default AuthorInfo;
